// 判断是不是全是中文
export const isFullCn = (str: string) => {
  return /.*[\u4e00-\u9fa5]+.*/.test(str)
}
